import { AppContext } from "../context/context";
import React, { useContext, useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";

const Home = ({ children }) => {
  const { state } = useContext(AppContext);
  const navigate = useNavigate();

  // Memoized tab and route configuration
  const tabConfig = useMemo(() => {
    return state.activeTab === "ABCD App"
      ? [
          { label: "PDFs", route: "/admin/pdf" },
          { label: "URLs", route: "/admin/url" },
          { label: "Cache", route: "/admin/cache" },
          { label: "Questions", route: "/admin/questions" },
          { label: "Deep Links", route: "/admin/deeplinks" },
          { label: "Analytics", route: "/admin/analytics" },
          { label: "Error Logs", route: "/admin/error" },
          { label: "Api Monitor", route: "/admin/api_monitor" }
        ]
      : [
          { label: "PDFs", route: "/admin/pdf" },
          { label: "URLs", route: "/admin/url" },
          { label: "Cache", route: "/admin/cache" },
          { label: "Questions", route: "/admin/questions" },
          { label: "Deep Links", route: "/admin/deeplinks" },
          { label: "Analytics", route: "/admin/analytics" },
          { label: "Error Logs", route: "/admin/error" },
          { label: "Api Monitor", route: "/admin/api_monitor" }
        ];
  }, [state.activeTab]);

  // Active tab state
  const [activeTab, setActiveTab] = useState(0);

  // Handle tab change
  const handleTabChange = (index) => {
    setActiveTab(index);
    navigate(tabConfig[index].route);
  };

  // Update active tab and navigate when `state.activeTab` changes
  useEffect(() => {
    setActiveTab(0); // Reset active tab to 0
    navigate(tabConfig[0]?.route); // Navigate to the first route
  }, [state.activeTab, tabConfig]);

  // Set active tab on initial load
  useEffect(() => {
    const currentPath = window.location.pathname;
    const index = tabConfig.findIndex((tab) => tab.route === currentPath);
    if (index !== -1) setActiveTab(index);
  }, [tabConfig]);

  // Styles for active/inactive tabs
  const activeTabStyle = "border-b-2 border-b-[#4D4D4D] font-semibold z-[1]";
  const inactiveTabStyle = "border-b-2 border-b-transparent";

  return (
    <div className="homePage h-full w-full bg-[#FBFDFE] px-5">
      <div className="tabs h-[48px] border-[#ECECEC] pt-2 w-full flex justify-between">
        <div className="w-full flex h-full">
          {tabConfig.map((tab, index) => (
            <button
              key={index}
              className={`focus:outline-0 px-2 min-w-16 pt-1.5 pb-1 text-md cursor-pointer ${
                activeTab === index ? activeTabStyle : inactiveTabStyle
              }`}
              onClick={() => handleTabChange(index)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>
      <hr className="h-0 border-t-2 border-[#ECECEC] transform translate-y-[-2px]" />
      {children}
    </div>
  );
};

export default Home;
